import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';

export class APISetPluginInstanceEnableManager extends APIBaseManager<{ pluginInstanceID: string }, void, { enabled: boolean }, any> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_SetPluginInstanceEnable';
        this._apiMethod = 'PATCH';
        this._allowPayloadPrint = false;
    }

    protected getRequestURL(pathParameters: { pluginInstanceID: string }, queryParameters: void): string {
        return super.getRequestURL() + 'pluginInstances/' + pathParameters.pluginInstanceID + '/enable';
    }
}